import React, { useState } from 'react';
import { motion } from 'framer-motion';
import {
  PageContainer,
  ContentGrid,
  ContentRow,
  Card,
  CardTitle,
  CardContent,
  ActionBar,
  Button,
  SearchInput,
  Table,
  TableHeader,
  TableRow,
  TableCell,
  StatusBadge,
  TabContainer,
  TabList,
  Tab,
  TabContent,
  fadeIn
} from '../styles/PageStyles';
import PageHeaderWithInfo from '../components/common/PageHeaderWithInfo';
import { faVault } from '@fortawesome/free-solid-svg-icons';

const FraudVault = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [activeTab, setActiveTab] = useState('cases');

  // Mock data for fraud cases
  const fraudCases = [
    { id: 'FRD-001', type: 'Identity Theft', severity: 'high', status: 'investigating', date: '2025-03-15', confidence: 0.89, source: 'Claims' },
    { id: 'FRD-002', type: 'Billing Fraud', severity: 'medium', status: 'resolved', date: '2025-03-12', confidence: 0.94, source: 'Billing' },
    { id: 'FRD-003', type: 'Document Forgery', severity: 'high', status: 'escalated', date: '2025-03-16', confidence: 0.92, source: 'Underwriting' },
    { id: 'FRD-004', type: 'Multiple Claims', severity: 'low', status: 'monitoring', date: '2025-03-14', confidence: 0.76, source: 'Claims' },
    { id: 'FRD-005', type: 'Provider Fraud', severity: 'medium', status: 'investigating', date: '2025-03-17', confidence: 0.85, source: 'Network' },
  ];

  // Filter cases based on search term
  const filteredCases = fraudCases.filter(caseItem =>
    caseItem.id.toLowerCase().includes(searchTerm.toLowerCase()) ||
    caseItem.type.toLowerCase().includes(searchTerm.toLowerCase()) ||
    caseItem.source.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Get severity badge color
  const getSeverityColor = (severity) => {
    switch (severity) {
      case 'low': return 'default';
      case 'medium': return 'warning';
      case 'high': return 'error';
      default: return 'default';
    }
  };

  // Get status badge color
  const getStatusColor = (status) => {
    switch (status) {
      case 'resolved': return 'active';
      case 'monitoring': return 'default';
      case 'investigating': return 'warning';
      case 'escalated': return 'error';
      default: return 'default';
    }
  };

  return (
    <PageContainer>
      <motion.div
        initial="hidden"
        animate="visible"
        variants={fadeIn}
      >
        <PageHeaderWithInfo
          icon={faVault}
          title="Fraud Vault"
          description="AI-powered fraud detection system that identifies suspicious patterns, anomalies, and potential fraud cases
          across claims, billing, and other insurance processes."
        >
          <div style={{ display: 'flex', gap: '1rem' }}>
            {activeTab === 'cases' && (
              <SearchInput
                type="text"
                placeholder="Search claims..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            )}

            <Button primary>Report Suspicious Activity</Button>
          </div>
        </PageHeaderWithInfo>


        <TabContainer>
          <TabList>
            <Tab active={activeTab === 'cases'} onClick={() => setActiveTab('cases')}>Fraud Cases</Tab>
            <Tab active={activeTab === 'patterns'} onClick={() => setActiveTab('patterns')}>Fraud Patterns</Tab>
            <Tab active={activeTab === 'analytics'} onClick={() => setActiveTab('analytics')}>Analytics</Tab>
          </TabList>

          <TabContent active={activeTab === 'cases'}>
            {/* <ActionBar>
              <SearchInput
                type="text"
                placeholder="Search cases..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <Button>Filter</Button>
              <Button>Sort</Button>
            </ActionBar> */}

            {/* <ContentGrid>
              <Card>
                <CardTitle>Fraud Overview</CardTitle>
                <CardContent>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1rem' }}>
                    <div>
                      <div style={{ fontSize: '2rem', fontWeight: 'bold', color: 'var(--primary)' }}>43</div>
                      <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>Total Cases</div>
                    </div>
                    <div>
                      <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#FFCC00' }}>18</div>
                      <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>Investigating</div>
                    </div>
                    <div>
                      <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#FF3B30' }}>7</div>
                      <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>Escalated</div>
                    </div>
                    <div>
                      <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#34C759' }}>15</div>
                      <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>Resolved</div>
                    </div>
                  </div>
                </CardContent>
              </Card>
              
              <Card>
                <CardTitle>Fraud by Source</CardTitle>
                <CardContent>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '0.8rem' }}>
                    <div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.3rem' }}>
                        <span>Claims</span>
                        <span>42%</span>
                      </div>
                      <div style={{ width: '100%', height: '8px', background: 'rgba(0,102,255,0.1)', borderRadius: '4px' }}>
                        <div style={{ width: '42%', height: '8px', background: 'var(--primary)', borderRadius: '4px' }}></div>
                      </div>
                    </div>
                    
                    <div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.3rem' }}>
                        <span>Billing</span>
                        <span>28%</span>
                      </div>
                      <div style={{ width: '100%', height: '8px', background: 'rgba(0,102,255,0.1)', borderRadius: '4px' }}>
                        <div style={{ width: '28%', height: '8px', background: 'var(--primary)', borderRadius: '4px' }}></div>
                      </div>
                    </div>
                    
                    <div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.3rem' }}>
                        <span>Underwriting</span>
                        <span>15%</span>
                      </div>
                      <div style={{ width: '100%', height: '8px', background: 'rgba(0,102,255,0.1)', borderRadius: '4px' }}>
                        <div style={{ width: '15%', height: '8px', background: 'var(--primary)', borderRadius: '4px' }}></div>
                      </div>
                    </div>
                    
                    <div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.3rem' }}>
                        <span>Provider Network</span>
                        <span>10%</span>
                      </div>
                      <div style={{ width: '100%', height: '8px', background: 'rgba(0,102,255,0.1)', borderRadius: '4px' }}>
                        <div style={{ width: '10%', height: '8px', background: 'var(--primary)', borderRadius: '4px' }}></div>
                      </div>
                    </div>
                    
                    <div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.3rem' }}>
                        <span>Other</span>
                        <span>5%</span>
                      </div>
                      <div style={{ width: '100%', height: '8px', background: 'rgba(0,102,255,0.1)', borderRadius: '4px' }}>
                        <div style={{ width: '5%', height: '8px', background: 'var(--primary)', borderRadius: '4px' }}></div>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </ContentGrid> */}

            <Card
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
            >
              <CardTitle>Recent Fraud Cases</CardTitle>
              <Table>
                <thead>
                  <tr>
                    <TableHeader>Case ID</TableHeader>
                    <TableHeader>Type</TableHeader>
                    <TableHeader>Source</TableHeader>
                    <TableHeader>Date Detected</TableHeader>
                    <TableHeader>AI Confidence</TableHeader>
                    <TableHeader>Severity</TableHeader>
                    <TableHeader>Status</TableHeader>
                    <TableHeader>Actions</TableHeader>
                  </tr>
                </thead>
                <tbody>
                  {filteredCases.map(caseItem => (
                    <TableRow key={caseItem.id}>
                      <TableCell>{caseItem.id}</TableCell>
                      <TableCell>{caseItem.type}</TableCell>
                      <TableCell>{caseItem.source}</TableCell>
                      <TableCell>{caseItem.date}</TableCell>
                      <TableCell>{(caseItem.confidence * 100).toFixed(0)}%</TableCell>
                      <TableCell>
                        <StatusBadge status={getSeverityColor(caseItem.severity)}>
                          {caseItem.severity}
                        </StatusBadge>
                      </TableCell>
                      <TableCell>
                        <StatusBadge status={getStatusColor(caseItem.status)}>
                          {caseItem.status}
                        </StatusBadge>
                      </TableCell>
                      <TableCell>
                        <div style={{ display: 'flex', gap: '0.5rem' }}>
                          <Button style={{ padding: '0.3rem 0.6rem', fontSize: '0.8rem' }}>Details</Button>
                          {caseItem.status !== 'resolved' && (
                            <Button primary style={{ padding: '0.3rem 0.6rem', fontSize: '0.8rem' }}>Investigate</Button>
                          )}
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
                </tbody>
              </Table>
            </Card>
          </TabContent>

          <TabContent active={activeTab === 'patterns'}>
            <ContentRow>
              <Card style={{ flex: 1, minWidth: '300px' }}>
                <CardTitle>Detected Fraud Patterns</CardTitle>
                <Table>
                  <thead>
                    <tr>
                      <TableHeader>Pattern Name</TableHeader>
                      <TableHeader>Type</TableHeader>
                      <TableHeader>Detection Rate</TableHeader>
                      <TableHeader>Last Detected</TableHeader>
                      <TableHeader>Status</TableHeader>
                    </tr>
                  </thead>
                  <tbody>
                    <TableRow>
                      <TableCell>Multiple Claims Same Injury</TableCell>
                      <TableCell>Claims</TableCell>
                      <TableCell>92%</TableCell>
                      <TableCell>2025-03-15</TableCell>
                      <TableCell><StatusBadge status="active">Active</StatusBadge></TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Upcoding Services</TableCell>
                      <TableCell>Billing</TableCell>
                      <TableCell>88%</TableCell>
                      <TableCell>2025-03-16</TableCell>
                      <TableCell><StatusBadge status="active">Active</StatusBadge></TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Identity Verification Anomalies</TableCell>
                      <TableCell>Underwriting</TableCell>
                      <TableCell>94%</TableCell>
                      <TableCell>2025-03-14</TableCell>
                      <TableCell><StatusBadge status="active">Active</StatusBadge></TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Phantom Services</TableCell>
                      <TableCell>Provider</TableCell>
                      <TableCell>91%</TableCell>
                      <TableCell>2025-03-12</TableCell>
                      <TableCell><StatusBadge status="active">Active</StatusBadge></TableCell>
                    </TableRow>
                  </tbody>
                </Table>
              </Card>
            </ContentRow>
          </TabContent>

          <TabContent active={activeTab === 'analytics'}>
            <ContentGrid>
              <Card>
                <CardTitle>Fraud Detection Trends</CardTitle>
                <CardContent>
                  <div style={{ height: '200px', display: 'flex', alignItems: 'flex-end', gap: '12px', marginTop: '20px' }}>
                    {[12, 15, 9, 18, 22, 16, 24].map((value, index) => (
                      <div key={index} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <div style={{ height: `${value * 6}px`, width: '100%', background: 'var(--primary)', borderRadius: '4px 4px 0 0' }}></div>
                        <div style={{ fontSize: '0.7rem', marginTop: '5px' }}>{`W${index + 1}`}</div>
                      </div>
                    ))}
                  </div>
                  <div style={{ textAlign: 'center', marginTop: '10px', fontSize: '0.8rem', color: 'var(--text-secondary)' }}>
                    Cases Detected - Last 7 Weeks
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardTitle>Financial Impact</CardTitle>
                <CardContent>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', marginTop: '20px' }}>
                    <div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span>Potential Fraud Detected</span>
                        <span style={{ fontWeight: 'bold', color: 'var(--text-primary)' }}>$1,245,800</span>
                      </div>
                    </div>

                    <div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span>Confirmed Fraud</span>
                        <span style={{ fontWeight: 'bold', color: 'var(--text-primary)' }}>$782,350</span>
                      </div>
                    </div>

                    <div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span>Prevented Losses</span>
                        <span style={{ fontWeight: 'bold', color: '#34C759' }}>$625,200</span>
                      </div>
                    </div>

                    <div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span>Recovery In Progress</span>
                        <span style={{ fontWeight: 'bold', color: '#FFCC00' }}>$157,150</span>
                      </div>
                    </div>

                    <div style={{ marginTop: '1rem', padding: '1rem', background: 'rgba(52, 199, 89, 0.1)', borderRadius: '8px' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span style={{ fontWeight: 'bold' }}>ROI on Fraud Prevention</span>
                        <span style={{ fontWeight: 'bold', color: '#34C759' }}>412%</span>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </ContentGrid>
          </TabContent>
        </TabContainer>
      </motion.div>
    </PageContainer>
  );
};

export default FraudVault;
